/**
 * Sort objects based on given key in ascending order
 *
 * @param {array} data
 * @param {string} key
 * @returns {*}
 */
export const SortASC = (data, key= '') => {
    if (!Array.isArray(data) || data.length < 1) {
        return [];
    }

    if (!key) {
        return data.sort();
    }

    return data.sort((a, b) => {
        if (a[key] < b[key]) { return -1; }
        if (a[key] > b[key]) { return 1; }
        return 0;
    });
};
